import { initFBPixel, removeFBPixel } from './fbPixel'
import { initGA4, removeGA4 } from './ga'
import { initSentry } from './sentry'

export const initThirdPartyCookies = () => {
  initGA4()
  initFBPixel()
  initSentry()
}

export const removeThirdPartyCookies = () => {
  removeGA4()
  removeFBPixel()
}
